import ProgressBarTsoPq from '@components/LoadingSpinners/ProgressBarTsoPq';

const LoadingComponent = () => {
  return <ProgressBarTsoPq />;
};

export default LoadingComponent;
